export default "__VITE_ASSET__$D2ZXojB__"